import Button from "@app/components/move2Library/Button/Button"
import { SelectBox } from "@app/components/move2Library/SelectBox/SelectBox"
import { useGetStrings } from "@app/store/service/cmsService"
import { Modal } from "@tecreation/funnel-components"
import { useState } from "react"
export const MyParadisePickPaymentMethodModal = ({ onClose, paymentGroups, submitPayment }) => {
	const { data: strings } = useGetStrings(undefined, { defaultData: {} })

	const { preferredPaymentSubModalTitle, buttonSave, pleaseSelect } = strings
	const [paymentDetailId, setPaymentDetailId] = useState()

	return (
		<Modal className="myParadisePickPaymentMethodModal">
			<Modal.Header>{preferredPaymentSubModalTitle}</Modal.Header>
			<Modal.Closer onClick={onClose} />
			<Modal.Body>
				<div className="flex flex-column flex-items-center">
					<SelectBox
						onChange={e => {
							setPaymentDetailId(e.target.value)
						}}
						value=""
					>
						<option value="" disabled>
							{pleaseSelect}*
						</option>
						{paymentGroups &&
							paymentGroups.map(group => {
								return group.funnels[0].paymentDetailIds.map((p, i) => {
									const payment = p.payment_id
									if (!payment.paymentDetailId) return null
									if (!payment.cacheable) return null
									return (
										<option key={i} value={payment.paymentId + ";" + payment.paymentDetailId}>
											{payment.payment}
										</option>
									)
								})
							})}
					</SelectBox>
					<Button
						style="secondary"
						className="mt-3"
						onClick={() => {
							submitPayment(paymentDetailId.split(";")[1], paymentDetailId.split(";")[0])
						}}
					>
						{buttonSave}
					</Button>
				</div>
			</Modal.Body>
		</Modal>
	)
}
